<template>
    <!--we need this fake width so that the menu does not overlap on the content-->

    <!--main navigation component-->
    <!--:fixed="!alwaysExpanded"-->
    <v-navigation-drawer
      @update:rail="v => mini = v"
      rail-width="52"
      floating
      :mobile="false"
      :temporary="isTemporary"
      :model-value="isTemporary ? isDrawerOpen : true"
      @update:model-value="v => isDrawerOpen = v"
      :rail="!isTemporary && !alwaysExpanded"
      :expand-on-hover="!isTemporary && !alwaysExpanded"
      :style="isTemporary ? undefined : 'transform: none'"
      :class="{
        'navigation':true,
        'navigation--mini': mini
      }"
      width="220"
    >
      <!--logo-->
      <div class="navigation__top-fixed">
        <router-link
          to="/"
          class="navigation__logo"
          id="navigation-logo"
          @click="closeDrawer"
        >
          <v-img
            src="/img/logo-fire.svg"
            :height="21"
            :max-width="16"
          />
          <v-img
            v-if="!mini || alwaysExpanded"
            :src="logoTypeSrc"
            class="navigation__logo__type"
            :height="14"
            :max-width="116"
          />
        </router-link>

        <v-divider />
      </div>

      <dropdowns-change-business
        v-if="isBusinessContact"
        :mini="mini"
      />

      <v-divider v-if="isBusinessContact"/>

      <!-- Menu items. The order structure is Chapter > Item > Submenu -->
      <template
        v-for="(chapter, index) in items"
      >
        <v-divider
          v-if="index !== 0 && chapter.submenu.length"
          :key="chapter.title"
        />

        <!--chapters-->
        <v-list
          v-if="chapter.submenu.length"
          :key="chapter.title"
          density="compact"
          :nav="mini"
        >
          <v-list-subheader v-if="!mini">{{ chapter.label }}</v-list-subheader>

          <template v-for="item in chapter.submenu">
            <!--item with submenu-->
            <v-list-group
              v-if="item.submenu"
              :key="item.label"
              color="primary"
              ref="itemsWithSubmenu"
              :style="{minHeight: mini ? '35px' : '40px'}"
            >
              <template #activator="{ props }">
                <v-list-item
                  rounded="xl"
                  v-bind="props"
                  :title="item.title"
                  :value="checkActiveSubmenu(item)"
                  :class="{
                    'v-list-item--active': checkActiveSubmenu(item),
                    'text-primary': checkActiveSubmenu(item)
                  }"
                >
                  <v-icon class="mr-4">
                    {{ item.icon }}
                  </v-icon>

                  <span>{{ item.label }}</span>
                </v-list-item>
              </template>

              <!--submenu items-->
              <template v-if="!mini">
                <v-list-item
                  v-for="subitem in item.submenu"
                  :key="subitem.name"
                  :title="subitem.title"
                  :to="subitem.paths[0]"
                  color="primary"
                  ripple
                  class="navigation__submenu"
                  :style="{height: '40px'}"
                  @click="closeDrawer"
                >
                  <div class="navigation__submenu_icon">
                    <span></span>
                  </div>

                  <span>{{ subitem.label }}</span>
                </v-list-item>
              </template>
            </v-list-group>

            <!--item-->
            <v-list-item
              v-else
              :key="item.name"
              color="primary"
              rounded="xl"
              :to="item.paths[0]"
              :class="{'v-list-item--active': checkActiveItem(item)}"
              :active="checkActiveItem(item)"
              :exact="item.isExact ? item.isExact : false"
              :style="{minHeight: mini ? '35px' : '40px'}"
              @click="shrinkSubmenus(); closeDrawer()"
            >
              <v-icon
                :class="{
                  'mr-4': !mini,
                  'material-icons-outlined': true
                }"
              >
                {{ item.icon }}
              </v-icon>

              <span v-if="!mini">
                {{ item.label }}
              </span>
            </v-list-item>
          </template>
        </v-list>
      </template>

      <!-- Learning Help Center -->
      <template v-if="canSeeFAQ">
        <v-divider/>

        <v-list density="compact">
          <v-list-subheader v-if="!mini">Learning</v-list-subheader>

          <v-list-item
            color="primary"
            href="https://help.business.pepper.com/help"
            target="_blank"
            :style="{minHeight: mini ? '36px' : '40px'}"
            rounded="xl"
            :nav="mini"
          >
            <v-icon
              :class="{
                'mr-4': !mini,
                'material-icons-outlined': true
              }"
            >
              help_outline
            </v-icon>

            <span>Help Center</span>
          </v-list-item>
        </v-list>
      </template>

      <v-list
        v-if="!isTemporary"
        class="mt-16 navigation__expand-btn"
        density="compact"
      >
        <v-list-item
          :rounded="!mini ? 'xl' : 0"
          @click="toggleAlwaysExpanded"
          :nav="mini"
        >
          <v-icon
            :class="{
              'mr-4': !mini,
              'material-icons-outlined': true
            }"
          >
            {{ alwaysExpanded ? 'keyboard_backspace' : 'start' }}
          </v-icon>

          <span>{{ alwaysExpanded ? 'Collapse' : 'Expand' }}</span>
        </v-list-item>
      </v-list>

      <div v-if="!mini" class="navigation__bottom-fixed">
        <v-divider />

        <user-menu
          :mini="mini"
          :open-logout-dialog="openLogoutDialog"
        />
      </div>
    </v-navigation-drawer>

    <dialog-confirm
      :text="$t('are_you_sure_you_want_to_log_out')"
      :is-on="isLogoutDialogOn"
      :is-loading="isLoggingOut"
      :on-cancel="() => isLogoutDialogOn = false"
      :on-confirm="logout"
      class="logout-confirm"
    />
</template>

<script>
  // TODO return columns
  // import columns from '../config/loggedTabs';
  import { isBool } from '@/utils';

  export default {
    data() {
      return {
        isLogoutDialogOn: false,
        isLoggingOut: false,
        alwaysExpanded: false,
        items: [],
        // columns,
        mini: true,
      };
    },
    emits: ['mini'],
    computed: {
      isTemporary() {
        return this.$vuetify.display.mdAndDown;
      },
      isDrawerOpen: {
        get() {
          return this.$store.getters['navigation/isDrawerOpen'];
        },
        set(isOpen) {
          this.$store.dispatch('navigation/setDrawerOpen', isOpen);
        },
      },
      activeUser() {
        return this.$store.getters['auth/user'];
      },
      isBusinessContact() {
        const { is_business_role } = this.activeUser.role || {};
        return is_business_role || false;
      },
      permissions() {
        return this.$store.getters['auth/permissions'];
      },
      canSeeFAQ() {
        const permissions = [{
          subject: 'faq',
          actions: ['see-link-and-download']
        }]
        return this.isAuthorized({permissions});
      },
      logoTypeSrc() {
        return this.$vuetify.theme.global.name === 'dark'
          ? '/img/logo-type-dark.svg'
          : '/img/logo-type.svg';
      },
    },
    watch: {
      activeUser: {
        handler() {
          this.items = this.updateItems();
        },
        immediate: true,
        deep: true
      },
      isTemporary(isTemporary) {
        this.mini = !isTemporary && !this.alwaysExpanded;
        this.isDrawerOpen = false;
      },
      $route() {
        this.isDrawerOpen = false;
      },
      mini(val) {
        if (!val && !this.isTemporary) {
          // focus main navigation link on hover, to close global country dropdown
          document.getElementById('navigation-logo').focus();
        }
        this.$emit('mini', val);
      }
    },
    beforeMount() {
      const widgetId = import.meta.env.VUE_APP_GROOVE_WIDGET_ID;

      if (window && window.groove && !window.groove.widget && this.isBusinessContact) {
        window.groove.widget = window.groove.createWidget();
        window.groove.widget.init(widgetId, {});
      } else if (window && window.groove && window.groove.widget && !this.isBusinessContact) {
        window.groove.widget.destroy();
      }
    },
    beforeUnmount() {
      // Logging out unmounts the navigation from inside the open drawer, before
      // any route change could close it, and the state outlives this component.
      this.isDrawerOpen = false;
    },
    created() {
      const { activeUser } = this;
      this.items = this.updateItems();

      const isAlwaysExpanded = localStorage.getItem('isNavigationExpanded')
      if (isAlwaysExpanded !== null) {
        this.alwaysExpanded = !!JSON.parse(isAlwaysExpanded);
      }
      this.mini = !this.isTemporary && !this.alwaysExpanded;

      // todo check if needs emit for input
      // this.$emit('input', this.alwaysExpanded);
      this.$emit('mini', this.mini);
    },
    methods: {
      // A tap on the current page's link is a duplicate navigation that leaves
      // $route as it is, so the $route watcher can't close the drawer for it.
      closeDrawer() {
        if (this.isTemporary) {
          this.isDrawerOpen = false;
        }
      },
      shrinkSubmenus() {
        if (this.$refs?.itemsWithSubmenu) {
          this.$refs.itemsWithSubmenu.forEach((item) => {
            item.isActive = false;
          });
        }
      },
      openLogoutDialog() {
        this.isLogoutDialogOn = true;
      },
      logout() {
        this.isLoggingOut = true;

        return this.$store
          .dispatch('auth/logout')
          .catch((err) => err)
          .finally(() => {
            this.isLoggingOut = false;
          });
      },
      checkActiveSubmenu(item) {
        return item.submenu.some((subitem) => this.checkActiveItem(subitem))
      },
      checkActiveItem(subitem) {
        const currentPath = this.$route.path;
        let isActive = false;
        subitem?.paths?.forEach(i => {
          if (subitem.isExact && currentPath === i) {
            isActive = true;
          }
          if (!subitem.isExact && currentPath.startsWith(i)) {
            isActive = true;
          }
        });
        return isActive;
      },
      toggleAlwaysExpanded() {
        this.alwaysExpanded = !this.alwaysExpanded;
        setTimeout(() => {
          this.mini = false;
        }, 0)

        localStorage.setItem('isNavigationExpanded', this.alwaysExpanded)
      },
      updateItems() {
        // hardcoded config file (config/LoggedTabs), cos columns for unknown reason is being cached
        // and is not updating after relogin to different role
        const columns = [
          {
            name: 'thread',
            label: 'Deals',
            permissions: [{
              subject: 'thread',
              actions: ['view-nav-link']
            }],
            submenu: [
              {
                name: 'all-deals',
                icon: 'local_offer',
                label: 'All deals',
                paths: ['/threads'],
                permissions: [{
                  subject: 'thread',
                  actions: ['view']
                }],
              },
              {
                name: 'scheduled-threads',
                icon: 'dvr',
                label: 'Scheduled threads',
                paths: ['/scheduled-threads'],
                permissions: [{
                  subject: 'schedule-thread',
                  actions: ['list-all']
                }],
              },
              {
                name: 'pins',
                icon: 'push_pin',
                label: 'Pins',
                paths: ['/pins'],
                permissions: [{
                  subject: 'pin',
                  actions: ['list-all']
                }],
              },
            ]
          },
          {
            name: 'promotions',
            label: 'Promotions',
            permissions: [{
              subject: 'ad-manager.order',
              actions: ['view-nav-link']
            }],
            submenu: [
              {
                name: 'all-promotions',
                icon: 'trending_up',
                label: 'All promotions',
                paths: ['/promotions', '/promotions-archived'],
                permissions: [{
                  subject: 'ad-manager.order',
                  actions: ['view-nav-link']
                }],
                isExact: true,
              },
              {
                name: 'sponsorships',
                icon: 'bolt',
                label: 'Logo Sponsorship',
                paths: ['/sponsorships'],
                permissions: [{
                  subject: 'sponsorship',
                  actions: ['list-all']
                }],
              },
              {
                name: 'promotions-deals',
                icon: 'local_offer',
                label: 'Promotable deals',
                paths: ['/promotable-deals'],
                permissions: [{
                  subject: 'ad-manager.order',
                  actions: ['view-business-contact']
                }],
                isExact: true
              }
            ]
          },
          {
            name: 'events',
            label: 'Events',
            permissions: [{
              subject: 'event.assets',
              actions: ['list-all']
            }],
            submenu: [
              {
                name: 'events',
                icon: 'date_range',
                label: 'Event promotion',
                paths: ['/events/promotion'],
                permissions: [{
                  subject: 'event.promotions',
                  actions: ['list-all']
                }],
              },
              {
                name: 'event-assets',
                icon: 'image',
                label: 'Event assets',
                paths: ['/events/assets'],
                permissions: [{
                  subject: 'event.assets',
                  actions: ['list-all']
                }],
            },
            ],
          },
          {
            name: 'tracking_management',
            label: 'Tracking management',
            permissions: [{
              subject: 'clicky-advertisers',
              actions: ['list-all']
            }],
            submenu: [
              {
                name: 'tracking',
                icon: 'preview',
                label: 'Tracking',
                paths: ['/tracking-management'],
                permissions: [{
                  subject: 'clicky-advertisers',
                  actions: ['list-all']
                }],
              },
              {
                name: 'networks',
                icon: 'hub',
                label: 'Networks',
                paths: ['/tracking-networks'],
                permissions: [{
                  subject: 'clicky-networks',
                  actions: ['list-all']
                }],
              },
            ],
          },
          {
            name: 'reports',
            label: 'Analytics',
            permissions: [{
              subject: 'reports-tab',
              actions: ['view']
            }],
            submenu: [
              {
                name: 'performance-reports',
                icon: 'analytics',
                label: 'Reports',
                paths: ['/reports'],
                permissions: [{
                  subject: 'performance-reports',
                  actions: ['list-all']
                }],
                isExact: true
              },
              {
                name: 'daily-reports',
                icon: 'mouse',
                label: 'CPC Reports',
                paths: ['/reports/daily', '/reports/daily/advanced'],
                permissions: [{
                  subject: 'cpc-reports',
                  actions: ['view']
                }],
                isExact: true
              },
              {
                name: 'daily-reports-cpm',
                icon: 'remove_red_eye',
                label: 'CPM Reports',
                paths: ['/reports/daily-cpm'],
                permissions: [{
                  subject: 'cpm-reports',
                  actions: ['view']
                }],
                isExact: true
              }
            ]
          },
          {
            name: 'business',
            label: 'Business',
            permissions: [],
            submenu: [
              {
                name: 'accounts',
                icon: 'domain',
                label: 'Accounts',
                paths: ['/users'],
                permissions: [
                  {
                    subject: 'user',
                    actions: ['view-nav-link']
                  }
                ],
                submenu: [
                  {
                    name: 'business',
                    icon: 'business_center',
                    label: 'Businesses',
                    paths: ['/businesses'],
                    permissions: [{
                      subject: 'business',
                      actions: ['view-nav-link', 'list-all']
                    }],
                  },
                  {
                    name: 'user',
                    icon: 'supervisor_account',
                    label: 'Users',
                    paths: ['/users', '/users/pending'],
                    permissions: [
                      {
                        subject: 'user',
                        actions: ['view-nav-link']
                      }
                    ],
                  },
                ],
              },
              {
                name: 'billing',
                icon: 'receipt_long',
                label: 'Billing',
                permissions: [],
                submenu: [
                  {
                    name: 'payment',
                    icon: 'payment',
                    label: 'Payments',
                    paths: ['/payments'],
                    permissions: [{
                      subject: 'payment',
                      actions: ['list-all']
                    }],
                  },
                  {
                    name: 'invoice',
                    icon: 'event',
                    label: 'Invoices',
                    paths: ['/invoices'],
                    permissions: [{
                      subject: 'invoice',
                      actions: ['list-all']
                    }]
                  },
                  {
                    name: 'billing-accounts',
                    icon: 'credit_card',
                    label: 'Accounts',
                    paths: ['/billing', '/network-review'],
                    permissions: [{
                      subject: 'billing',
                      actions: ['list-all']
                    }],
                  },
                ],
              },
              {
                name: 'billing-reports',
                icon: 'credit_card',
                label: 'Billings',
                paths: ['/reports/monthly'],
                permissions: [{
                  subject: 'billing-reports',
                  actions: ['view']
                }],
              },
              {
                name: 'business-users',
                icon: 'supervisor_account',
                label: 'Members',
                paths: ['/business-users'],
                permissions: [{
                  subject: 'user',
                  actions: ['view-nav-link-business']
                }],
              },
              {
                name: 'contract',
                icon: 'request_quote',
                label: 'Price contracts',
                paths: ['/contracts'],
                permissions: [{
                  subject: 'contract',
                  actions: ['list-all']
                }],
              },
            ]
          },
          {
            name: 'creator_program',
            label: 'Creator program',
            permissions: [],
            submenu: [
              {
                name: 'creator-program-businesses',
                icon: 'leaderboard',
                label: 'Creators businesses',
                paths: ['/creator-program/businesses'],
                permissions: [
                  {
                    subject: 'loyalty_program',
                    actions: ['list-all'],
                  },
                ],
              },
              {
                name: 'creator-program-billing',
                icon: 'account_balance_wallet',
                label: 'Billing accounts',
                paths: ['/creator-program/billing-accounts'],
                permissions: [
                  {
                    subject: 'loyalty_program',
                    actions: ['list-all'],
                  },
                ],
              },
            ]
          },
          {
            name: 'administration',
            label: 'Administration',
            permissions: [],
            submenu: [
              {
                name: 'canned-replies',
                icon: 'chat',
                label: 'Canned replies',
                paths: ['/canned-replies'],
                permissions: [{
                  subject: 'comment',
                  actions: ['list-all']
                }],
              },
              {
                name: 'label',
                icon: 'label',
                label: 'Labels',
                paths: ['/labels'],
                permissions: [{
                  subject: 'label',
                  actions: ['view']
                }],
              },
              {
                name: 'internal_users',
                icon: 'badge',
                label: 'Internal users',
                paths: ['/internal-users'],
                permissions: [{
                  subject: 'banner',
                  actions: ['view']
                }],
              },
              {
                name: 'site-messages',
                icon: 'picture_in_picture',
                label: 'Site messages',
                paths: ['/site-messages'],
                permissions: [{
                  subject: 'banner',
                  actions: ['view']
                }],
              },
              {
                name: 'package',
                icon: 'collections_bookmark',
                label: 'Packages',
                paths: ['/packages'],
                permissions: [{
                  subject: 'package',
                  actions: ['view']
                }],
              },
            ]
          },
        ];

        // structure is: Chapters -> Items -> Subitems
        // filter chapters
        const filteredItems = columns.filter(chapter => this.isAuthorized(chapter))

        // filter items
        filteredItems.forEach(chapter => {
          if (chapter.submenu.length) {
            // eslint-disable-next-line no-param-reassign
            chapter.submenu = chapter.submenu.filter((item) => {
              const isAuthorized = this.isAuthorized(item)
              if (isAuthorized && item?.submenu?.length) {
                item.submenu = item.submenu.filter(subItem => this.isAuthorized(subItem))
                return 0 < item?.submenu?.length
              } else {
                return isAuthorized
              }
            });
          }
        })

        return filteredItems.map(item => {
          const nextItem = item;

          if (nextItem.submenu.length) {
            nextItem.submenu = nextItem.submenu.map(submenuItem => {
              if (submenuItem.submenu?.length) {
                return {
                  ...submenuItem,
                  isSelected: this.checkActiveSubmenu(submenuItem)
                };
              }

              return {
                ...submenuItem,
              }
            });
          }

          return {
            ...nextItem,
          };
        });
      },
      isAuthorized(item) {
        return this.$store.getters['auth/isAuthorized'](item.permissions);
      },
    }
  };
</script>

<style lang="scss">
  @use 'sass:map';
  @use '../assets/styles/theme' as *;

  .navigation {
    max-height: 100vh;

    &.v-navigation-drawer--floating {
      border-right: 1px solid rgba(var(--v-theme-on-surface), 0.12);
    }

    .v-divider {
      border-color: rgba(var(--v-theme-on-surface), 0.12);
      opacity: 1;
    }

    .v-list--density-compact .v-list-subheader {
      padding-inline-start: 8px !important;
      height: 40px;
    }

    .v-list-subheader__text {
      color: map.get($colors, grey, base);
      font-weight: 700;
      font-size: 12px;
      line-height: 15px;
      text-transform: uppercase;

      .v-theme--dark & {
        color: rgba(var(--v-theme-on-surface), 0.6);
      }
    }

    &.v-navigation-drawer .v-list {
      padding: 8px;
      overflow: initial;
    }

    .v-list .v-icon {
      color: rgba(var(--v-theme-on-surface), 0.87);
    }

    .v-list .v-list-item__title {
      font-weight: 700;
    }

    .v-list .v-list-item--active .v-icon {
      color: inherit;
    }

    .v-list-item__content {
      align-items: center;
      display: flex;
      overflow: hidden;
      white-space: nowrap;

      span {
        font-size: 13px;
        font-weight: 500;
      }
    }

    .v-list-item {
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &--mini {
      .v-list-item--nav {
        padding-left: 6px;

        .v-list-item__content {
          min-width: 24px !important;
        }
      }
    }
  }

  .navigation__expand-btn {
    flex-grow: 1;
    display: flex;
    align-items: flex-end;
  }

  .navigation__logo {
    align-items: center;
    background-color: rgb(var(--v-theme-surface));
    display: flex;
    height: 72px;
    padding: 0 24px 0;
    transition: all .2s;
    gap: 4px;

    &__type {
      margin: 14px 0 2px 2px;
    }

    &:focus,
    &:active,
    &:focus-visible {
      outline: none;
    }
  }

  .navigation__top-fixed {
    background-color: rgb(var(--v-theme-surface));
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .navigation__bottom-fixed {
    background-color: rgb(var(--v-theme-surface));
    position: -webkit-sticky; /* Safari */
    position: sticky;
    bottom: 0;
    z-index: 1;
  }

  .v-list-group__items .navigation__submenu.v-list-item {
    padding-inline-start: 16px !important;

    .v-list-item--one-line {
      padding: 0;
      padding-inline-start: 0 !important;
      font-size: 13px;
      font-weight: 500;
    }
  }

  .navigation__submenu_icon {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 24px;
    margin-right: 16px;
    width: 24px;

    span {
      background-color: rgb(var(--v-theme-primary));
      height: 100%;
      transition: width .3s ease-in-out;
      width: 1px;
    }
  }

  .v-list-item.v-list-item--active {
    .navigation__submenu_icon span {
      border-radius: 3px;
      height: 19px;
      width: 19px;
    }
  }

  .v-navigation-drawer--fixed {
    overflow: visible;
  }

  .v-navigation-drawer--is-mouseover.v-navigation-drawer--open-on-hover {
    border-right: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  }

  .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
  }

  // Hide scrollbar for navigation drawer
  .v-navigation-drawer::-webkit-scrollbar,
  .v-navigation-drawer__content::-webkit-scrollbar{
    display: none;
  }
  .v-navigation-drawer,
  .v-navigation-drawer__content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  /* Hide scrollbar for content */
  .v-navigation-drawer--rail .v-navigation-drawer__content::-webkit-scrollbar {
    display: none;
  }
  .v-navigation-drawer--rail .v-navigation-drawer__content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  .v-navigation-drawer--rail {
    .navigation__logo {
      padding: 0 18px 0;
    }
  }
</style>
